export const formatOptions = [
  { value: 'MM/DD/YYYY', label: 'MM/DD/YYYY' },
  { value: 'DD/MM/YYYY', label: 'DD/MM/YYYY' },
  { value: 'DD MMMM YYYY', label: 'DD MMMM YYYY' },
  { value: 'DD MMM YYYY', label: 'DD MMM YYYY' },
  { value: 'YYYY-MM-DD', label: 'YYYY-MM-DD' },
  // {value: 'HH:mm:ss', label: 'HH:mm:ss'},
  { value: 'YYYY-MM-DD HH:mm:ss', label: 'YYYY-MM-DD HH:mm:ss' },
  { value: 'MMMM Do YYYY, h:mm:ss a', label: 'MMMM Do YYYY, h:mm:ss a' },
  { value: 'dddd, MMMM Do YYYY, h:mm:ss a', label: 'dddd, MMMM Do YYYY, h:mm:ss a' },
  { value: 'YYYY-MM-DDTHH:mm:ssZ', label: 'YYYY-MM-DDTHH:mm:ssZ' },
]

export const _timeZones = [
  'Asia/Jakarta',
  'Africa/Abidjan',
  'Africa/Algiers',
  'Africa/Bissau',
  'Africa/Cairo',
  'Africa/Casablanca',
  'Africa/Ceuta',
  'Africa/El_Aaiun',
  'Africa/Johannesburg',
  'Africa/Juba',
  'Africa/Khartoum',
  'Africa/Lagos',
  'Africa/Maputo',
  'Africa/Monrovia',
  'Africa/Nairobi',
  'Africa/Ndjamena',
  'Africa/Sao_Tome',
  'Africa/Tripoli',
  'Africa/Tunis',
  'Africa/Windhoek',
  'America/Adak',
  'America/Anchorage',
  'America/Araguaina',
  'America/Argentina/Buenos_Aires',
  'America/Argentina/Catamarca',
  'America/Argentina/Cordoba',
  'America/Argentina/Jujuy',
  'America/Argentina/La_Rioja',
  'America/Argentina/Mendoza',
  'America/Argentina/Rio_Gallegos',
  'America/Argentina/Salta',
  'America/Argentina/San_Juan',
  'America/Argentina/San_Luis',
  'America/Argentina/Tucuman',
  'America/Argentina/Ushuaia',
  'America/Asuncion',
  'America/Bahia',
  'America/Bahia_Banderas',
  'America/Barbados',
  'America/Belem',
  'America/Belize',
  'America/Boa_Vista',
  'America/Bogota',
  'America/Boise',
  'America/Cambridge_Bay',
  'America/Campo_Grande',
  'America/Cancun',
  'America/Caracas',
  'America/Cayenne',
  'America/Chicago',
  'America/Chihuahua',
  'America/Ciudad_Juarez',
  'America/Costa_Rica',
  'America/Cuiaba',
  'America/Danmarkshavn',
  'America/Dawson',
  'America/Dawson_Creek',
  'America/Denver',
  'America/Detroit',
  'America/Edmonton',
  'America/Eirunepe',
  'America/El_Salvador',
  'America/Fort_Nelson',
  'America/Fortaleza',
  'America/Glace_Bay',
  'America/Goose_Bay',
  'America/Grand_Turk',
  'America/Guatemala',
  'America/Guayaquil',
  'America/Guyana',
  'America/Halifax',
  'America/Havana',
  'America/Hermosillo',
  'America/Indiana/Indianapolis',
  'America/Indiana/Knox',
  'America/Indiana/Marengo',
  'America/Indiana/Petersburg',
  'America/Indiana/Tell_City',
  'America/Indiana/Vevay',
  'America/Indiana/Vincennes',
  'America/Indiana/Winamac',
  'America/Inuvik',
  'America/Iqaluit',
  'America/Jamaica',
  'America/Juneau',
  'America/Kentucky/Louisville',
  'America/Kentucky/Monticello',
  'America/La_Paz',
  'America/Lima',
  'America/Los_Angeles',
  'America/Maceio',
  'America/Managua',
  'America/Manaus',
  'America/Martinique',
  'America/Matamoros',
  'America/Mazatlan',
  'America/Menominee',
  'America/Merida',
  'America/Metlakatla',
  'America/Mexico_City',
  'America/Miquelon',
  'America/Moncton',
  'America/Monterrey',
  'America/Montevideo',
  'America/New_York',
  'America/Nome',
  'America/Noronha',
  'America/North_Dakota/Beulah',
  'America/North_Dakota/Center',
  'America/North_Dakota/New_Salem',
  'America/Nuuk',
  'America/Ojinaga',
  'America/Panama',
  'America/Paramaribo',
  'America/Phoenix',
  'America/Port-au-Prince',
  'America/Porto_Velho',
  'America/Puerto_Rico',
  'America/Punta_Arenas',
  'America/Rankin_Inlet',
  'America/Recife',
  'America/Regina',
  'America/Resolute',
  'America/Rio_Branco',
  'America/Santarem',
  'America/Santiago',
  'America/Santo_Domingo',
  'America/Sao_Paulo',
  'America/Scoresbysund',
  'America/Sitka',
  'America/St_Johns',
  'America/Swift_Current',
  'America/Tegucigalpa',
  'America/Thule',
  'America/Tijuana',
  'America/Toronto',
  'America/Vancouver',
  'America/Whitehorse',
  'America/Winnipeg',
  'America/Yakutat',
  'Antarctica/Casey',
  'Antarctica/Davis',
  'Antarctica/Macquarie',
  'Antarctica/Mawson',
  'Antarctica/Palmer',
  'Antarctica/Rothera',
  'Antarctica/Troll',
  'Antarctica/Vostok',
  'Asia/Almaty',
  'Asia/Amman',
  'Asia/Anadyr',
  'Asia/Aqtau',
  'Asia/Aqtobe',
  'Asia/Ashgabat',
  'Asia/Atyrau',
  'Asia/Baghdad',
  'Asia/Baku',
  'Asia/Bangkok',
  'Asia/Barnaul',
  'Asia/Beirut',
  'Asia/Bishkek',
  'Asia/Chita',
  'Asia/Choibalsan',
  'Asia/Colombo',
  'Asia/Damascus',
  'Asia/Dhaka',
  'Asia/Dili',
  'Asia/Dubai',
  'Asia/Dushanbe',
  'Asia/Famagusta',
  'Asia/Gaza',
  'Asia/Hebron',
  'Asia/Ho_Chi_Minh',
  'Asia/Hong_Kong',
  'Asia/Hovd',
  'Asia/Irkutsk',
  'Asia/Jayapura',
  'Asia/Jerusalem',
  'Asia/Kabul',
  'Asia/Kamchatka',
  'Asia/Karachi',
  'Asia/Kathmandu',
  'Asia/Khandyga',
  'Asia/Kolkata',
  'Asia/Krasnoyarsk',
  'Asia/Kuching',
  'Asia/Macau',
  'Asia/Magadan',
  'Asia/Makassar',
  'Asia/Manila',
  'Asia/Nicosia',
  'Asia/Novokuznetsk',
  'Asia/Novosibirsk',
  'Asia/Omsk',
  'Asia/Oral',
  'Asia/Pontianak',
  'Asia/Pyongyang',
  'Asia/Qatar',
  'Asia/Qostanay',
  'Asia/Qyzylorda',
  'Asia/Riyadh',
  'Asia/Sakhalin',
  'Asia/Samarkand',
  'Asia/Seoul',
  'Asia/Shanghai',
  'Asia/Singapore',
  'Asia/Srednekolymsk',
  'Asia/Taipei',
  'Asia/Tashkent',
  'Asia/Tbilisi',
  'Asia/Tehran',
  'Asia/Thimphu',
  'Asia/Tokyo',
  'Asia/Tomsk',
  'Asia/Ulaanbaatar',
  'Asia/Urumqi',
  'Asia/Ust-Nera',
  'Asia/Vladivostok',
  'Asia/Yakutsk',
  'Asia/Yangon',
  'Asia/Yekaterinburg',
  'Asia/Yerevan',
  'Atlantic/Azores',
  'Atlantic/Bermuda',
  'Atlantic/Canary',
  'Atlantic/Cape_Verde',
  'Atlantic/Faroe',
  'Atlantic/Madeira',
  'Atlantic/South_Georgia',
  'Atlantic/Stanley',
  'Australia/Adelaide',
  'Australia/Brisbane',
  'Australia/Broken_Hill',
  'Australia/Darwin',
  'Australia/Eucla',
  'Australia/Hobart',
  'Australia/Lindeman',
  'Australia/Lord_Howe',
  'Australia/Melbourne',
  'Australia/Perth',
  'Australia/Sydney',
  'CET',
  'CST6CDT',
  'EET',
  'EST',
  'EST5EDT',
  'Etc/GMT',
  'Etc/GMT+1',
  'Etc/GMT+10',
  'Etc/GMT+11',
  'Etc/GMT+12',
  'Etc/GMT+2',
  'Etc/GMT+3',
  'Etc/GMT+4',
  'Etc/GMT+5',
  'Etc/GMT+6',
  'Etc/GMT+7',
  'Etc/GMT+8',
  'Etc/GMT+9',
  'Etc/GMT-1',
  'Etc/GMT-10',
  'Etc/GMT-11',
  'Etc/GMT-12',
  'Etc/GMT-13',
  'Etc/GMT-14',
  'Etc/GMT-2',
  'Etc/GMT-3',
  'Etc/GMT-4',
  'Etc/GMT-5',
  'Etc/GMT-6',
  'Etc/GMT-7',
  'Etc/GMT-8',
  'Etc/GMT-9',
  'Etc/UTC',
  'Europe/Andorra',
  'Europe/Astrakhan',
  'Europe/Athens',
  'Europe/Belgrade',
  'Europe/Berlin',
  'Europe/Brussels',
  'Europe/Bucharest',
  'Europe/Budapest',
  'Europe/Chisinau',
  'Europe/Dublin',
  'Europe/Gibraltar',
  'Europe/Helsinki',
  'Europe/Istanbul',
  'Europe/Kaliningrad',
  'Europe/Kirov',
  'Europe/Kyiv',
  'Europe/Lisbon',
  'Europe/London',
  'Europe/Madrid',
  'Europe/Malta',
  'Europe/Minsk',
  'Europe/Moscow',
  'Europe/Paris',
  'Europe/Prague',
  'Europe/Riga',
  'Europe/Rome',
  'Europe/Samara',
  'Europe/Saratov',
  'Europe/Simferopol',
  'Europe/Sofia',
  'Europe/Tallinn',
  'Europe/Tirane',
  'Europe/Ulyanovsk',
  'Europe/Vienna',
  'Europe/Vilnius',
  'Europe/Volgograd',
  'Europe/Warsaw',
  'Europe/Zurich',
  'HST',
  'Indian/Chagos',
  'Indian/Maldives',
  'Indian/Mauritius',
  'MET',
  'MST',
  'MST7MDT',
  'PST8PDT',
  'Pacific/Apia',
  'Pacific/Auckland',
  'Pacific/Bougainville',
  'Pacific/Chatham',
  'Pacific/Easter',
  'Pacific/Efate',
  'Pacific/Fakaofo',
  'Pacific/Fiji',
  'Pacific/Galapagos',
  'Pacific/Gambier',
  'Pacific/Guadalcanal',
  'Pacific/Guam',
  'Pacific/Honolulu',
  'Pacific/Kanton',
  'Pacific/Kiritimati',
  'Pacific/Kosrae',
  'Pacific/Kwajalein',
  'Pacific/Marquesas',
  'Pacific/Nauru',
  'Pacific/Niue',
  'Pacific/Norfolk',
  'Pacific/Noumea',
  'Pacific/Pago_Pago',
  'Pacific/Palau',
  'Pacific/Pitcairn',
  'Pacific/Port_Moresby',
  'Pacific/Rarotonga',
  'Pacific/Tahiti',
  'Pacific/Tarawa',
  'Pacific/Tongatapu',
  'WET',
]

// export const timeZones = _timeZones.map((timeZone: string) => {
//   return {value: timeZone, label: timeZone}
// })

export const timeZones = [
  { label: "(UTC-12:00) International Date Line West", utcOffset: -12, utcString: "(UTC-12:00)", value: "Etc/GMT+12" },
  { label: "(UTC-11:00) Coordinated Universal Time-11", utcOffset: -11, utcString: "(UTC-11:00)", value: "Etc/GMT+11" },
  { label: "(UTC-10:00) Hawaii", utcOffset: -10, utcString: "(UTC-10:00)", value: "Pacific/Honolulu" },
  { label: "(UTC-09:30) Marquesas", utcOffset: -9.5, utcString: "(UTC-09:30)", value: "Pacific/Marquesas" },
  { label: "(UTC-09:00) Alaska/Gambier Islands", utcOffset: -9, utcString: "(UTC-09:00)", value: "Pacific/Gambier" },
  { label: "(UTC-08:00) Los Angeles/Pacific Time (US & Canada)", utcOffset: -8, utcString: "(UTC-08:00)", value: "Etc/GMT+8" },
  { label: "(UTC-07:00) Denver/Mountain Time (US & Canada)", utcOffset: -7, utcString: "(UTC-07:00)", value: "Etc/GMT+7" },
  { label: "(UTC-06:00) Chicago/Central Time (US & Canada)", utcOffset: -6, utcString: "(UTC-06:00)", value: "Etc/GMT+6" },
  { label: "(UTC-05:00) New_York/Eastern Time (US & Canada)", utcOffset: -5, utcString: "(UTC-05:00)", value: "Etc/GMT+5" },
  // { label: "(UTC-04:30) Venezuela", utcOffset: -4.5, utcString: "(UTC-04:30)", value: "America/Caracas" },
  { label: "(UTC-04:00) Atlantic Time (Canada)", utcOffset: -4, utcString: "(UTC-04:00)", value: "Etc/GMT+4" },
  // { label: "(UTC-03:30) Newfoundland", utcOffset: -3.5, utcString: "(UTC-03:30)", value: "America/St_Johns" },
  { label: "(UTC-03:00) Argentina, Brazil, Georgetown", utcOffset: -3, utcString: "(UTC-03:00)", value: "America/Argentina/Buenos_Aires" },
  { label: "(UTC-02:00) Mid-Atlantic", utcOffset: -2, utcString: "(UTC-02:00)", value: "Atlantic/South_Georgia" },
  { label: "(UTC-01:00) Azores, Cape Verde Islands", utcOffset: -1, utcString: "(UTC-01:00)", value: "Atlantic/Azores" },
  { label: "(UTC+00:00) Greenwich Mean Time", utcOffset: 0, utcString: "(UTC+00:00)", value: "Etc/GMT" },
  { label: "(UTC+01:00) Central European Time", utcOffset: 1, utcString: "(UTC+01:00)", value: "Europe/Berlin" },
  { label: "(UTC+02:00) Eastern European Time", utcOffset: 2, utcString: "(UTC+02:00)", value: "Europe/Athens" },
  { label: "(UTC+03:00) Moscow, Baghdad, Nairobi", utcOffset: 3, utcString: "(UTC+03:00)", value: "Europe/Moscow" },
  { label: "(UTC+03:30) Tehran", utcOffset: 3.5, utcString: "(UTC+03:30)", value: "Asia/Tehran" },
  { label: "(UTC+04:00) Dubai, Baku, Yerevan", utcOffset: 4, utcString: "(UTC+04:00)", value: "Asia/Dubai" },
  { label: "(UTC+04:30) Kabul", utcOffset: 4.5, utcString: "(UTC+04:30)", value: "Asia/Kabul" },
  { label: "(UTC+05:00) Pakistan, Tashkent", utcOffset: 5, utcString: "(UTC+05:00)", value: "Asia/Karachi" },
  { label: "(UTC+05:30) India, Sri Lanka", utcOffset: 5.5, utcString: "(UTC+05:30)", value: "Asia/Kolkata" },
  { label: "(UTC+05:45) Nepal", utcOffset: 5.75, utcString: "(UTC+05:45)", value: "Asia/Kathmandu" },
  { label: "(UTC+06:00) Bangladesh, Bhutan", utcOffset: 6, utcString: "(UTC+06:00)", value: "Asia/Dhaka" },
  { label: "(UTC+06:30) Myanmar (Burma)", utcOffset: 6.5, utcString: "(UTC+06:30)", value: "Asia/Rangoon" },
  { label: "(UTC+07:00) Bangkok, Jakarta, Hanoi", utcOffset: 7, utcString: "(UTC+07:00)", value: "Asia/Jakarta" },
  { label: "(UTC+08:00) Beijing, Singapore, Perth", utcOffset: 8, utcString: "(UTC+08:00)", value: "Asia/Singapore" },
  { label: "(UTC+08:45) Eucla", utcOffset: 8.75, utcString: "(UTC+08:45)", value: "Australia/Eucla" },
  { label: "(UTC+09:00) Japan, Korea", utcOffset: 9, utcString: "(UTC+09:00)", value: "Asia/Tokyo" },
  { label: "(UTC+09:30) Adelaide, Darwin", utcOffset: 9.5, utcString: "(UTC+09:30)", value: "Australia/Darwin" },
  { label: "(UTC+10:00) Brisbane, Port Moresby", utcOffset: 10, utcString: "(UTC+10:00)", value: "Australia/Brisbane" },
  { label: "(UTC+10:30) Broken Hill", utcOffset: 10.5, utcString: "(UTC+10:30)", value: "Australia/Broken_Hill" },
  { label: "(UTC+11:00) Solomon Islands, New Caledonia", utcOffset: 11, utcString: "(UTC+11:00)", value: "Pacific/Guadalcanal" },
  // { label: "(UTC+11:30) Etc/GMT-11:30", utcOffset: 11.5, utcString: "(UTC+11:30)", value: "Etc/GMT-11:30" },
  { label: "(UTC+12:00) Majuro, Kiribati", utcOffset: 12, utcString: "(UTC+12:00)", value: "Pacific/Majuro" },
  // { label: "(UTC+12:45) Chatham Islands", utcOffset: 12.75, utcString: "(UTC+12:45)", value: "Pacific/Chatham" },
  { label: "(UTC+13:00) Samoa", utcOffset: 13, utcString: "(UTC+13:00)", value: "Pacific/Apia" },
  { label: "(UTC+14:00) Line Islands", utcOffset: 14, utcString: "(UTC+14:00)", value: "Pacific/Kiritimati" },
];


export const timeLocales = [
  { value: "id", label: "Indonesian" },
  { value: "en", label: "English" },
  { value: "en-US", label: "English (United States)" },
  { value: "en-GB", label: "English (United Kingdom)" },
  // { value: "en-CA", label: "English (Canada)" },
  // { value: "en-AU", label: "English (Australia)" },
  // { value: "en-NZ", label: "English (New Zealand)" },
  // { value: "en-IN", label: "English (India)" },
  // { value: "en-ZA", label: "English (South Africa)" },
  { value: "ar", label: "Arabic" },
  { value: "fr", label: "French" },
  // { value: "fr-FR", label: "French (France)" },
  // { value: "fr-CA", label: "French (Canada)" },
  // { value: "fr-BE", label: "French (Belgium)" },
  // { value: "fr-CH", label: "French (Switzerland)" },
  // { value: "fr-LU", label: "French (Luxembourg)" },
  { value: "de", label: "German" },
  // { value: "de-DE", label: "German (Germany)" },
  // { value: "de-AT", label: "German (Austria)" },
  // { value: "de-CH", label: "German (Switzerland)" },
  { value: "es", label: "Spanish" },
  // { value: "es-ES", label: "Spanish (Spain)" },
  // { value: "es-MX", label: "Spanish (Mexico)" },
  { value: "it", label: "Italian" },
  // { value: "it-IT", label: "Italian (Italy)" },
  // { value: "it-CH", label: "Italian (Switzerland)" },
  { value: "ja", label: "Japanese" },
  { value: "ko", label: "Korean" },
  { value: "zh-CN", label: "Chinese (Simplified)" },
  { value: "zh-TW", label: "Chinese (Traditional)" },
];

export const currencyCodeOption = [
  {
    value: 'IDR',
    label: 'IDR',
  },
  {
    value: 'MYR',
    label: 'MYR',
  },
  {
    value: 'USD',
    label: 'USD',
  },
]

export const currencylocales = [
  { label: 'IDN', value: 'id-ID', name: 'Indonesia', currencyCode: 'IDR', currencySymbol: 'Rp.' }, // Indonesia
  { label: 'USA', value: 'en-US', name: 'United States', currencyCode: 'USD', currencySymbol: '$' }, // Amerika Serikat
  { label: 'CAN', value: 'en-CA', name: 'Canada', currencyCode: 'CAD', currencySymbol: '$' }, // Kanada
  { label: 'GBR', value: 'en-GB', name: 'United Kingdom', currencyCode: 'GBP', currencySymbol: '£' }, // Inggris
  { label: 'DEU', value: 'de-DE', name: 'Germany', currencyCode: 'EUR', currencySymbol: '€' }, // Jerman
  { label: 'FRA', value: 'fr-FR', name: 'France', currencyCode: 'EUR', currencySymbol: '€' }, // Prancis
  { label: 'NLD', value: 'nl-NL', name: 'Netherlands', currencyCode: 'EUR', currencySymbol: '€' }, // Belanda
  { label: 'SWE', value: 'sv-SE', name: 'Sweden', currencyCode: 'SEK', currencySymbol: 'kr' }, // Swedia
  { label: 'DNK', value: 'da-DK', name: 'Denmark', currencyCode: 'DKK', currencySymbol: 'kr' }, // Denmark
  { label: 'FIN', value: 'fi-FI', name: 'Finland', currencyCode: 'EUR', currencySymbol: '€' }, // Finlandia
  { label: 'NOR', value: 'no-NO', name: 'Norway', currencyCode: 'NOK', currencySymbol: 'kr' }, // Norwegia
  { label: 'CHE', value: 'de-CH', name: 'Switzerland', currencyCode: 'CHF', currencySymbol: 'CHF' }, // Swiss (Jerman)
  { label: 'ITA', value: 'it-IT', name: 'Italy', currencyCode: 'EUR', currencySymbol: '€' }, // Italia
  { label: 'ESP', value: 'es-ES', name: 'Spain', currencyCode: 'EUR', currencySymbol: '€' }, // Spanyol
  { label: 'PRT', value: 'pt-PT', name: 'Portugal', currencyCode: 'EUR', currencySymbol: '€' }, // Portugal
  { label: 'POL', value: 'pl-PL', name: 'Poland', currencyCode: 'PLN', currencySymbol: 'zł' }, // Polandia
  { label: 'RUS', value: 'ru-RU', name: 'Russia', currencyCode: 'RUB', currencySymbol: '₽' }, // Rusia
  { label: 'JPN', value: 'ja-JP', name: 'Japan', currencyCode: 'JPY', currencySymbol: '¥' }, // Jepang
  { label: 'KOR', value: 'ko-KR', name: 'South Korea', currencyCode: 'KRW', currencySymbol: '₩' }, // Korea Selatan
  { label: 'CHN', value: 'zh-CN', name: 'China', currencyCode: 'CNY', currencySymbol: '¥' }, // Tiongkok
  { label: 'TWN', value: 'zh-TW', name: 'Taiwan', currencyCode: 'TWD', currencySymbol: 'NT$' }, // Taiwan
  { label: 'SGP', value: 'zh-SG', name: 'Singapore', currencyCode: 'SGD', currencySymbol: 'S$' }, // Singapura
  { label: 'HKG', value: 'zh-HK', name: 'Hong Kong', currencyCode: 'HKD', currencySymbol: 'HK$' }, // Hong Kong
  { label: 'IND', value: 'hi-IN', name: 'India', currencyCode: 'INR', currencySymbol: '₹' }, // India
]

